// Umiestnenie: frontend/src/index.tsx
// Vstupný bod aplikácie.
//
// Podľa adresy sa načíta jedna z dvoch aplikácií:
//
//   /admin/*, /prihlasenie...  → administrácia (app/App.tsx)
//   všetko ostatné             → verejný web v aktívnej šablóne (web/WebApp.tsx)

import React from 'react';
import ReactDOM from 'react-dom/client';
import { spustiNacitanie } from './web/nacitanie';

// Predpony, ktoré patria novej administrácii
const NOVE_CESTY = ['/admin', '/prihlasenie', '/zabudnute-heslo', '/obnova-hesla'];

const jeNovaAdministracia = (): boolean => {
  const cesta = window.location.pathname;
  return NOVE_CESTY.some((p) => cesta === p || cesta.startsWith(p + '/'));
};

const koren = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

/**
 * Dynamický import zabezpečí, že návštevník webu nesťahuje kód
 * administrácie a naopak.
 */
if (jeNovaAdministracia()) {
  // Jazyk sa nastaví pred načítaním administrácie - texty v menu
  // a konštantách sa vyhodnocujú pri načítaní modulov
  void import('./i18n')
    .then(async ({ nacitajJazyk, ulozenyJazyk }) => nacitajJazyk(await ulozenyJazyk()))
    .then(() => import('./app/App'))
    .then(({ default: App }) => {
      koren.render(
        <React.StrictMode>
          <App />
        </React.StrictMode>
      );
    });
} else {
  // Úvodná obrazovka, prvá obrazovka naraz a prechody medzi stránkami -
  // sledovanie požiadaviek musí bežať skôr, než web niečo stiahne
  spustiNacitanie();
  void import('./web/WebApp').then(({ default: WebApp }) => {
    koren.render(
      <React.StrictMode>
        <WebApp />
      </React.StrictMode>
    );
  });
}

// Service worker - push upozornenia a stránka „Ste offline" (public/sw.js)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((e) => console.warn('Service worker sa nepodarilo zaregistrovať:', e));
  });
}
